import { filter } from 'lodash';
import {
  SURVEY_TYPE_REGULAR,
  SURVEY_TYPE_DISTRIBUTION_LINK,
  SURVEY_TYPE_PEEQ,
  PEEQ_CATEGORY_TYPE_INVOICED,
  PEEQ_CATEGORY_TYPE_PREPAID,
} from 'containers/Survey/constants';
import { SURVEY_FLOW, SURVEY_STEPS } from './constants';

export const defaultSurveyType = ({
  surveyCreationFlow,
  isProdegeUser,
  regularSurvey: regular,
  hasDistributionLinkPerk: dLink,
  hasPeeqSurveyPerk: peeq,
}) => {
  if (!regular && !dLink && !peeq) {
    return false;
  }

  if (surveyCreationFlow === SURVEY_FLOW.THIRD_PARTY) {
    return SURVEY_TYPE_REGULAR;
  }

  const onlyRegular = regular && !dLink && !peeq;
  const onlyDLink = !regular && dLink && !peeq;
  const onlyPeeq = !regular && !dLink && peeq;
  const regularAndDLink = regular && dLink && !peeq;
  const regularAndPeeq = regular && !dLink && peeq;
  const dLinkAndPeeq = !regular && dLink && peeq;

  if (onlyRegular) return SURVEY_TYPE_REGULAR;
  if (onlyDLink) return SURVEY_TYPE_DISTRIBUTION_LINK;
  if (onlyPeeq) return SURVEY_TYPE_PEEQ;

  if (!isProdegeUser) {
    if (regularAndDLink) return SURVEY_TYPE_REGULAR;
    if (regularAndPeeq) return SURVEY_TYPE_REGULAR;
    if (dLinkAndPeeq) return SURVEY_TYPE_PEEQ;
    return SURVEY_TYPE_REGULAR;
  }

  if (regularAndDLink) return SURVEY_TYPE_DISTRIBUTION_LINK;
  if (regularAndPeeq) return SURVEY_TYPE_PEEQ;
  if (dLinkAndPeeq) return SURVEY_TYPE_PEEQ;
  return SURVEY_TYPE_PEEQ;
};

export const defaultCard = ({
  surveyCreationFlow,
  hasThirdParty,
  regularSurvey,
  hasDistributionLinkPerk,
  hasPeeqSurveyPerk,
  externalContentStepCount,
  isProdegeUser,
}) => {
  const selectedSurveyType = defaultSurveyType({
    surveyCreationFlow,
    isProdegeUser,
    regularSurvey,
    hasDistributionLinkPerk,
    hasPeeqSurveyPerk,
  });
  const hasOnlyOneCollector =
    filter([regularSurvey, hasDistributionLinkPerk, hasPeeqSurveyPerk])
      .length === 1;
  const hasNoCollector =
    !regularSurvey && !hasDistributionLinkPerk && !hasPeeqSurveyPerk;
  const hasMoreThanOneCollector = !hasOnlyOneCollector && !hasNoCollector;
  const isPeeqSurvey = selectedSurveyType === SURVEY_TYPE_PEEQ;

  if (hasNoCollector) {
    return '';
  }
  if (surveyCreationFlow === SURVEY_FLOW.THIRD_PARTY) {
    if (hasThirdParty && regularSurvey) {
      return SURVEY_STEPS.CREATION_LOADER;
    }
    return '';
  }
  if (hasMoreThanOneCollector) {
    return SURVEY_STEPS.AUDIENCE_SELECTION;
  }
  if (surveyCreationFlow === SURVEY_FLOW.REGULAR) {
    if (isPeeqSurvey) {
      return SURVEY_STEPS.PEEQ_SELECT;
    }
    return SURVEY_STEPS.CREATION_LOADER;
  }
  if (surveyCreationFlow === SURVEY_FLOW.TEMPLATE) {
    if (isPeeqSurvey) {
      return SURVEY_STEPS.PEEQ_SELECT;
    }
    if (externalContentStepCount === 0) {
      return SURVEY_STEPS.CREATION_LOADER;
    }
    if (externalContentStepCount !== 0) {
      return SURVEY_STEPS.TEMPLATE_VARIABLES;
    }
    return '';
  }
  return '';
};

export const defaultPeeqCategoryType = (isProdegeUser) => {
  if (isProdegeUser) {
    return PEEQ_CATEGORY_TYPE_INVOICED;
  }
  return PEEQ_CATEGORY_TYPE_PREPAID;
};
